import { useRect } from "@enfusion-ui/hooks";
import * as React from "react";
import { PositionedPortal } from "./PositionedPortal";
export const Portal = ({ children, attachedRef, align = "left", watchPosition = false, minWidth = "width", open, topOffset = 0, leftOffset = 0, ...props }) => {
    const scrollPos = useRect(attachedRef, open && watchPosition ? 1000 : null);
    const handleSetPlacement = React.useCallback((windowWidth, windowHeight, portalElementRef) => {
        if (attachedRef.current && portalElementRef.current) {
            // use the attachedRef to place the portal just under the selected item text
            const rect = attachedRef.current.getBoundingClientRect();
            const bottomOfAttached = rect.y + rect.height;
            const styles = {
                display: "block",
            };
            if (minWidth !== null) {
                styles.minWidth = `${minWidth === "width" ? rect.width : minWidth}px`;
            }
            const { width, height } = portalElementRef.current
                ? portalElementRef.current.getBoundingClientRect()
                : { width: 0, height: 0 };
            if (align === "left") {
                let left = rect.x;
                if (width + rect.x > windowWidth) {
                    left -= width + rect.x - windowWidth;
                }
                styles.left = `${left + leftOffset}px`;
            }
            if (align === "right") {
                styles.right = `${windowWidth - (rect.x + rect.width)}px`;
            }
            // place under attached by default
            let top = rect.y + rect.height;
            if (bottomOfAttached > windowHeight ||
                bottomOfAttached + height > windowHeight) {
                // place above attached
                top = rect.y - height;
            }
            // handle going under the view
            if (top + height > windowHeight) {
                top = windowHeight - height;
            }
            // handle going above the view
            if (top < 0) {
                top = 0;
            }
            styles.top = `${top + topOffset}px`;
            return styles;
        }
        return {};
    }, [scrollPos]);
    return (React.createElement(PositionedPortal, { open: open, ...props, setPlacement: handleSetPlacement, scrollPos: scrollPos }, children));
};
